<template>
  <div
    class="z-0 mt-3 flex flex-1 h-full max-w-full overflow-y-auto overflow-x-hidden bg-light-screen-background dark:bg-dark-screen-background">
    <div class="flex flex-row w-full h-full max-w-full mx-auto ml-4">
      <div :class="[`mr-4 mb-6 w-full h-full mx-auto overflow-visible`]">
        <div v-if="!is_create_milestone_template && !is_edit_milestone_template" class="flex w-full items-center">
          <div class="relative w-full rounded-md shadow-sm">
            <input
              v-model="default_template_filter"
              autocomplete="off"
              type="text"
              tabindex="1"
              :autofocus="true"
              name="search_for_templates"
              class="pl-10 form-input"
              :placeholder="$t('Search for activities templates')">
            <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <Search class="w-5 h-5 text-gray-400" aria-hidden="true" />
            </div>
          </div>
          <SelectInput
            :items="sort_options"
            :value="sort_option"
            name="templates_filter"
            label-attr="label"
            value-attr="value"
            :allow-null="true"
            :inline-label="true"
            :show-label="false"
            classes="w-fit h-full ml-1"
            input-classes="h-[42px]"
            :is-box-background="true"
            :label="$t('Sort by')"
            :return-ids="true"
            :placeholder="$t('Select item')"
            @update:currentItem="sort_option = $event" />
          <Menu v-slot="{ close }" ref="createMetricMenu" as="div" class="ml-1 w-fit relative flex-shrink-0">
            <MenuButton
              class="inline-flex items-center justify-center rounded-full w-36 border-1 focus:outline-none focus:ring-1 focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue">
              <div class="btn primary-btn">
                + {{ $t("Create New") }}
              </div>
            </MenuButton>
            <transition
              enter-active-class="transition duration-100 ease-out"
              enter-from-class="transform scale-95 opacity-0"
              enter-to-class="transform scale-100 opacity-100"
              leave-active-class="transition duration-75 ease-in"
              leave-from-class="transform scale-100 opacity-100"
              leave-to-class="transform scale-95 opacity-0">
              <MenuItems class="absolute z-50 w-40 -ml-48 origin-bottom-right bg-transparent border-0 focus:outline-none">
                <div class="py-1 p-3 bg-white border dark:border-dark-divider-border dark:bg-dark-screen-background rounded-lg w-[340px]">
                  <div
                    class="flex items-center py-2 bg-white opacity-90 hover:opacity-100 hover:cursor-pointer"
                    @click.prevent="
                      () => {
                        $emitter.emit(ALL_EMITTERS.UPDATE_PLAN, {
                          plan: {
                            name: '',
                            collaborators: [],
                            companies: [],
                            contacts: [],
                            description: '',
                            due_date: null,
                            start_date: null,
                            otype: 'plan',
                            status: 'pending',
                            tags: [],
                            type: ''
                          },
                          is_template: true
                        })
                        close()
                      }
                    ">
                    <Plus class="mx-3 w-6 h-6" /><span class="font-semibold">{{ $t("Plan template") }}</span>
                  </div>
                  <div
                    class="flex items-center py-2 bg-white opacity-90 hover:opacity-100 hover:cursor-pointer"
                    @click.prevent="
                      () => {
                        $emitter.emit(ALL_EMITTERS.UPDATE_GOAL, {
                          goal: {
                            name: '',
                            collaborators: [],
                            companies: [],
                            contacts: [],
                            description: '',
                            due_date: null,
                            start_date: null,
                            otype: 'goal',
                            status: 'pending',
                            tags: [],
                            type: ''
                          },
                          is_template: true
                        })
                        close()
                      }
                    ">
                    <Plus class="mx-3 w-6 h-6" /><span class="font-semibold">{{ $t("Goal template") }}</span>
                  </div>
                  <div
                    class="flex items-center py-2 bg-white opacity-90 hover:opacity-100 hover:cursor-pointer"
                    @click.prevent="
                      () => {
                        $emitter.emit(ALL_EMITTERS.UPDATE_TASK, {
                          task: {
                            name: '',
                            collaborators: [],
                            companies: [],
                            contacts: [],
                            description: '',
                            due_date: null,
                            start_date: null,
                            otype: 'task',
                            status: 'pending',
                            tags: [],
                            type: ''
                          },
                          is_template: true
                        })
                        close()
                      }
                    ">
                    <Plus class="mx-3 w-6 h-6" /><span class="font-semibold">{{ $t("Task template") }}</span>
                  </div>
                  <div
                    class="flex items-center py-2 bg-white opacity-90 hover:opacity-100 hover:cursor-pointer"
                    @click.prevent="
                      () => {
                        $emitter.emit(ALL_EMITTERS.UPDATE_INTERACTION, {
                          interaction: {
                            name: '',
                            collaborators: [],
                            companies: [],
                            contacts: [],
                            description: '',
                            due_date: null,
                            start_date: null,
                            otype: 'interaction',
                            status: 'pending',
                            tags: [],
                            type: ''
                          },
                          is_template: true
                        })
                        close()
                      }
                    ">
                    <Plus class="mx-3 w-6 h-6" /><span class="font-semibold">{{ $t("Interaction template") }}</span>
                  </div>
                  <div
                    class="flex items-center py-2 bg-white opacity-90 hover:opacity-100 hover:cursor-pointer"
                    @click.prevent="
                      () => {
                        is_create_milestone_template = true
                        close()
                      }
                    ">
                    <Plus class="mx-3 w-6 h-6" /><span class="font-semibold">{{ $t("Milestone template") }}</span>
                  </div>
                </div>
              </MenuItems>
            </transition>
          </Menu>
        </div>
        <div v-if="!is_create_milestone_template && !is_edit_milestone_template" class="px-4 mt-3 sm:px-6 md:px-0">
          <div class="flex w-full flex-warp gap-x-1">
            <div
              v-for="tab in tabs"
              :key="tab"
              class="px-2 py-1 rounded-full border border-[#B3CAD6] cursor-pointer"
              :class="[selected_tab == tab ? 'bg-[#2DA7D7]' : 'bg-[#F5F8FA]']"
              @click="selected_tab = tab">
              {{ $t(tab) }}
            </div>
          </div>
          <div class="flex flex-col w-full">
            <div class="flex flex-col w-full">
              <div v-if="selected_tab == 'All' || selected_tab == 'Plan templates'" class="mt-8 mb-2 flex items-center">
                <span class="text-[20px] font-semibold">{{ $t("Plan templates") }}</span>
              </div>
              <div v-if="selected_tab == 'All' || selected_tab == 'Plan templates'" class="w-full h-full">
                <TemplateCard
                  :templates="templates.filter((t) => t.source_object_type == 'plan')"
                  :template-filter="default_template_filter"
                  source-object-type="plan"
                  class="w-full h-full" />
              </div>
              <div v-if="selected_tab == 'All' || selected_tab == 'Goal templates'" class="mt-8 mb-2 flex items-center">
                <span class="text-[20px] font-semibold">{{ $t("Goal templates") }}</span>
              </div>
              <div v-if="selected_tab == 'All' || selected_tab == 'Goal templates'" class="w-full h-full">
                <TemplateCard
                  :templates="templates.filter((t) => t.source_object_type == 'goal')"
                  :template-filter="default_template_filter"
                  source-object-type="goal"
                  class="w-full h-full" />
              </div>
              <div v-if="selected_tab == 'All' || selected_tab == 'Task templates'" class="mt-8 mb-2 flex items-center">
                <span class="text-[20px] font-semibold">{{ $t("Task templates") }}</span>
              </div>
              <div v-if="selected_tab == 'All' || selected_tab == 'Task templates'" class="w-full h-full">
                <TemplateCard
                  :templates="templates.filter((t) => t.source_object_type == 'task')"
                  :template-filter="default_template_filter"
                  source-object-type="task"
                  class="w-full h-full" />
              </div>
              <div v-if="selected_tab == 'All' || selected_tab == 'Interaction templates'" class="mt-8 mb-2 flex items-center">
                <span class="text-[20px] font-semibold">{{ $t("Interaction templates") }}</span>
              </div>
              <div v-if="selected_tab == 'All' || selected_tab == 'Interaction templates'" class="w-full h-full">
                <TemplateCard
                  :templates="templates.filter((t) => t.source_object_type == 'interaction')"
                  :template-filter="default_template_filter"
                  source-object-type="interaction"
                  class="w-full h-full" />
              </div>
              <div v-if="selected_tab == 'All' || selected_tab == 'Milestone templates'" class="mt-8 mb-2 flex items-center">
                <span class="text-[20px] font-semibold">{{ $t("Milestone templates") }}</span>
              </div>
              <div v-if="selected_tab == 'All' || selected_tab == 'Milestone templates'" class="w-full h-full">
                <TemplateCard
                  :templates="templates.filter((t) => t.source_object_type == 'milestone')"
                  :template-filter="default_template_filter"
                  source-object-type="milestone"
                  class="w-full h-full"
                  :show-load-more="selected_tab == 'All'"
                  @edit="
                    ($event) => {
                      template_to_be_edited = $event
                      is_edit_milestone_template = true
                    }
                  " />
              </div>
            </div>
          </div>
        </div>
        <div v-if="is_create_milestone_template || is_edit_milestone_template" class="w-full h-full mt-3">
          <MilestoneTemplate
            :edit-template="is_edit_milestone_template"
            :template="template_to_be_edited"
            class="relative w-full min-h-[500px] h-[500px]"
            @done="
              () => {
                is_create_milestone_template = false
                is_edit_milestone_template = false
                template_to_be_edited = null
              }
            "
            @cancel="
              () => {
                is_create_milestone_template = false
                is_edit_milestone_template = false
                template_to_be_edited = null
              }
            " />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectInput from "@/components/shared/SelectInput.vue"
import dataService from "@/services/data.service"
import TemplateCard from "@/components/shared/TemplateCard.vue"
import { Menu, MenuButton, MenuItems } from "@headlessui/vue"
import { Search, Plus } from "lucide-vue-next"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
import MilestoneTemplate from "@/components/shared/MilestoneTemplate.vue"

export default {
  components: {
    MilestoneTemplate,
    SelectInput,
    TemplateCard,
    Plus,
    Menu,
    MenuButton,
    MenuItems,
    Search
  },
  props: {},
  data() {
    return {
      ALL_EMITTERS,
      template_to_be_edited: null,
      is_edit_milestone_template: false,
      is_create_milestone_template: false,
      templates: [],
      sort_option: null,
      tabs: ["All", "Plan templates", "Goal templates", "Task templates", "Interaction templates", "Milestone templates"],
      selected_tab: "All",
      sort_options: [
        { label: this.$t("Created date"), value: "datetime_created" },
        { label: this.$t("Last modified"), value: "last_edited" },
        { label: this.$t("Name"), value: "name" }
      ],
      default_template_filter: null
    }
  },
  computed: {},
  watch: {
    sort_option() {
      if (this.sort_option == "datetime_created") {
        this.templates.sort((a, b) => {
          return new Date(b.datetime_created) - new Date(a.datetime_created)
        })
      } else if (this.sort_option == "last_edited") {
        this.templates.sort((a, b) => {
          return new Date(b.last_edited) - new Date(a.last_edited)
        })
      } else if (this.sort_option == "name") {
        this.templates.sort((a, b) => {
          return a.name.localeCompare(b.name)
        })
      } else {
        const params = { page_size: 100 }
        dataService.getTemplates(params).then((res) => {
          this.templates = res.data.results
        })
      }
    }
  },
  created() {
    const params = { page_size: 100 }
    dataService.getTemplates(params).then((res) => {
      this.templates = res.data.results
    })
    this.register_listeners()
  },
  activated() {
    this.register_listeners()
  },
  deactivated() {
    this.unregister_listeners()
  },
  methods: {
    register_listeners() {
      this.$emitter.on(ALL_EMITTERS.TEMPLATE_DELETED, (template_id) => {
        let index = this.templates.findIndex((item) => item.id == template_id)
        if (index != -1) {
          this.templates.splice(index, 1)
        }
      })
      this.$emitter.on(ALL_EMITTERS.NEW_ACTIVITY_TEMPLATE_ADDED, (template) => {
        let index = this.templates.findIndex((item) => item.id == template.id)
        if (index == -1) {
          this.templates.push(template)
        }
      })
      this.$emitter.on(ALL_EMITTERS.TEMPLATE_UPDATED, (template) => {
        let index = this.templates.findIndex((item) => item.id == template.id)
        if (index != -1) {
          this.templates[index] = this.$utils.clone(template)
        }
      })
    },
    unregister_listeners() {
      this.$emitter.off(ALL_EMITTERS.TEMPLATE_DELETED)
      this.$emitter.off(ALL_EMITTERS.NEW_ACTIVITY_TEMPLATE_ADDED)
      this.$emitter.off(ALL_EMITTERS.TEMPLATE_UPDATED)
    }
  }
}
</script>

<style>
.slide-fade-enter-active {
  transition: all 0.2s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.2s;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20);
  opacity: 0;
}
</style>
